export const LD_FLAGS = {
  SHOW_CLIENT_CONFIG: "showClientConfig",
  SHOW_WATCH_LIST: "showWatchlist",
  SHOW_CLIENT_UPLOAD: "showClientUpload",
  SHOW_JUNK_VALUES: "showJunkValues",
  SHOW_CONTROL_PANEL: "showControlPanel",
  SHOW_IGNORE_LIST: "showIgnoreList",
  SHOW_SCORING_RULES: "showScoringRules",
  SHOW_DATA_CLEANSING: "showCleansingPage",
  SHOW_TEMPLATES: "showTemplatePage",
  SHOW_MDA: "showMdaPage",
  SHOW_FILTER_OPTIONS: "showFilterOptionsCustomisePage",
  SHOW_MDA_SPREADSHEET_MAPPINGS: "showMdaSpreadsheetMappingsPage",
} as const;

export type LDFlagKey = (typeof LD_FLAGS)[keyof typeof LD_FLAGS];
